module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAjCAMAAAA+JdOiAAAAb1BMVEUAAAAAOD8AOD8ANz8AOD4AOD8ANz8AOEAANz4ANz8AOD8ANz4AOD4ANz4AOD0ANz4ANjsANTkAMzkALCwAOD4ANz4ANz4ANz8ANz4AOD0ANjoAOD8ANz4AOD8ANz8ANz4AOD4ANT4AN0AAMzoAOD8oeiViAAAAJHRSTlMA5Jr0f2nPZPCv+t/FdmRcMBMPBOnBnoRKSBzX1bWnkFY+PCNk7JwoAAAAj0lEQVQ4y+3NORaCQBBF0dJGbJlnFGd9+1+jDQczsIiMuFEFr84Xic+o7LVzIYuEuVRQbTQGErFcRLUDTwz+Wq7lWv6ttATNdlI3Vu6MIJYDc2wqzhgEmeQRs5riW5rhK0v2U3wgfA3l/VHID2Xbj7alK0+ieIZAXcNRNPkNpy91qYVhXfeOwBSyRJl4mfQ+huMng0ZdnswAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/mobile/xinxi.png
// module id = ExZX
// module chunks = 1